var _rect, _mask, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKgflagIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 20,
    rx: 2,
    fill: "white"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 20
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 20,
    rx: 2,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 20,
    fill: "#F22A46"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 13.3334C15.8409 13.3334 17.3333 11.841 17.3333 10.0001C17.3333 8.15913 15.8409 6.66675 14 6.66675C12.159 6.66675 10.6666 8.15913 10.6666 10.0001C10.6666 11.841 12.159 13.3334 14 13.3334Z",
    fill: "#FFF04D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3681 17.1495L14 14.7137L15.6318 17.1495L16.0451 14.2469L18.5722 15.7335L17.6852 12.9389L20.6071 13.1819L18.5954 11.0489L21.3333 10.0001L18.5954 8.95118L20.6071 6.81824L17.6852 7.06117L18.5722 4.26663L16.0451 5.75324L15.6318 2.85059L14 5.28644L12.3681 2.85059L11.9548 5.75324L9.4277 4.26663L10.3147 7.06117L7.39285 6.81824L9.40453 8.95118L6.66663 10.0001L9.40453 11.0489L7.39285 13.1819L10.3147 12.9389L9.4277 15.7335L11.9548 14.2469L12.3681 17.1495ZM18.6666 10.0001C18.6666 12.5774 16.5773 14.6667 14 14.6667C11.4226 14.6667 9.33329 12.5774 9.33329 10.0001C9.33329 7.42273 11.4226 5.33339 14 5.33339C16.5773 5.33339 18.6666 7.42273 18.6666 10.0001Z",
    fill: "#FFF04D"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKgflagIcon);
export default __webpack_public_path__ + "static/media/kgflag-icon.e4e00843.svg";
export { ForwardRef as ReactComponent };